<template>
	<div class="logo">
		<img :src="logoSrc" alt="" />
	</div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from "vue"
import teamingAppLogo from "@/assets/images/TeamingApplogo.png"
import teamingAppMini from "@/assets/images/TeamingApp.png"

defineOptions({
	name: "Logo"
})

const props = withDefaults(
	defineProps<{
		mini: boolean
		dark?: boolean
	}>(),
	{ dark: undefined }
)
const { mini } = toRefs(props)

const logoSrc = computed(() => (mini.value ? teamingAppMini : teamingAppLogo))
</script>

<style lang="scss" scoped>
.logo {
	height: 100%;
	display: flex;
	align-items: center;

	img {
		max-height: 32px;
		display: block;
		height: 100%;
	}

	&.fade-enter-active,
	&.fade-leave-active {
		transition: opacity var(--sidebar-anim-ease) var(--sidebar-anim-duration);
	}

	&.fade-enter-from,
	&.fade-leave-to {
		opacity: 0;
	}
}
</style>
